<div class="services_heading">
  <span>Services We Offer</span>
</div>
<div class="row">
  <div class="col-md-6 my-3_5 scale-container">
    <div class="scale-obj">
      <img class="img-fluid" src="assets/images/services_d_energy.svg" alt="services" />
    </div>
    <h2>Energy</h2>
    <p>
      We take the stress out of switching energy suppliers - making a complicated evaluation process easier.
    </p>
    <button mat-flat-button routerLink="/services/energy">Learn More</button>
  </div>
  <div class="col-md-6 my-3_5 scale-container">
    <div class="scale-obj">
      <img class="img-fluid" src="assets/images/services_m_contracts.svg" alt="services" />
    </div>
    <h2>Broadband Contracts</h2>
    <p>
     Helping you find the best deals with our award winning broadband services.
    </p>
    <button mat-flat-button routerLink="/services/broadband-contracts">Learn More</button>
  </div>
  <div class="col-md-6 my-3_5 scale-container">
    <div class="scale-obj">
      <img class="img-fluid" src="assets/images/services_insurance.svg" alt="services" />
    </div>
    <h2>Insurance</h2>
    <p>
      Compare quotes across a variety of types of insurance and start saving money today.
    </p>
    <button mat-flat-button routerLink="/services/insurance">Learn More</button>
  </div>
  <div class="col-md-6 my-3_5 scale-container">
    <div class="scale-obj">
      <img class="img-fluid" src="assets/images/Fundraising-02.svg" alt="services" />
    </div>
    <h2>Fundraising</h2>
    <p>
       We are passionate about charities, delivering ethical Face to Face fundraising solutions across venues and events, as well as the residential marketplace.
    </p>
    <button mat-flat-button routerLink="/services/fundraising">Learn More</button>
  </div>
  <div class="col-md-6 my-3_5 scale-container">
    <div class="scale-obj">
      <img class="img-fluid" src="assets/images/solarpaneltop.svg" alt="services" />
    </div>
    <h2>Solar Panel</h2>
    <p>
       We are passionate about charities, delivering ethical Face to Face fundraising solutions across venues and events, as well as the residential marketplace.
    </p>
    <button mat-flat-button routerLink="/services/solar-panel">Learn More</button>
  </div>
</div>